import { CapaBankCode } from './bank-code';

export interface State {
  isInitialized: boolean;
  isAuthenticated: boolean;
  userInfo: UserInfo | null;
}

export enum ACTION_TYPE_ENUM {
  INITIALIZE = 'INITIALIZE',
  SIGN_IN = 'SIGN_IN',
  SIGN_OUT = 'SIGN_OUT',
  SIGN_UP = 'SIGN_UP'
}

export type InitializeAction = {
  type: ACTION_TYPE_ENUM.INITIALIZE;
  payload: {
    isAuthenticated: boolean;
    userInfo: UserInfo | null;
  };
};

export type SignInAction = {
  type: ACTION_TYPE_ENUM.SIGN_IN;
  payload: {
    userInfo: UserInfo | null;
  };
};

export type SignUpAction = {
  type: ACTION_TYPE_ENUM.SIGN_UP;
};

export type SignOutAction = {
  type: ACTION_TYPE_ENUM.SIGN_OUT;
};

export type Action =
  | InitializeAction
  | SignInAction
  | SignOutAction
  | SignUpAction;

export type Handler = (state: State, action: any) => State;

export interface UserInfo {
  role: string[];
  friendId: string;
}
export interface AccessToken {
  iss: string;
  sub: string;
  iat: number;
  exp: number;
  roles: string[];
  friendId: string;
  userAgent: {
    iv: string;
    content: string;
  };
}

export interface AccessTokenInput {
  refreshToken: string;
  grant_type: 'refresh';
}

export interface AccessTokenOutput {
  result: {
    accessToken: string;
    refreshToken: string;
    tokenType: string;
  };
}

export interface AutoLogin {
  capaAccessToken: string;
  grant_type: 'token';
}
export interface LoginInput {
  email: string;
  password: string;
  grant_type: 'password';
}
export interface LoginOutput {
  result: {
    accessToken?: string;
    refreshToken?: string;
    tokenType?: string;
    statusTypeId?: number;
    rejectReason?: string;
  };
}

export interface VerifyEmailOutput {
  success: boolean;
  result: {
    authNumber: string;
    selectData: string;
  };
}

export interface VerifyCellphoneOutput {
  success: boolean;
  result: {
    impUid: string;
    merchantUid?: string;
    pgTid?: string;
    pgProvider: string;
    name?: string;
    gender?: string;
    birth?: number;
    birthday?: string;
    foreigner: boolean;
    phone?: string;
    carrier?: string;
    certified?: boolean;
    certifiedAt?: number;
    uniqueKey?: string;
    uniqueInSite?: string;
    origin?: string;
    foreignerV2?: boolean;
  };
}

export interface RegisterInput {
  email: string;
  password: string;
  friendsType: number;
  managerCellphone: string;
  managerName: string;
  birthday?: Date | string;
  ein?: string;
  einFileId?: number;
  bankcode?: CapaBankCode;
  accountNumber?: string;
  accountHolder?: string;
  bankbookFileId?: number;
  friendsName?: string;
  position?: string;
  industry?: string;
  parentFriendsId?: number | null;
  utmSource?: string | null;
  utmMedium?: string | null;
  utmCampaign?: string | null;
}

export interface RegisterOutput {
  success: boolean;
  exception: {
    statusCode: number;
    error: string;
    message: string;
  } | null;
}

export enum USER_TYPE_ENUM {
  PERSONAL = '1',
  BUSINESS = '2',
  GROUP = '3'
}
